export enum SortType {
  String = 'string',
  Date = 'date',
  Number = 'number',
  Duration = 'duration',
  Timestamp = 'timestamp',
}
